<template>
  <base-section
    v-if="hasRenderableContent"
    id="about"
    :space="isMobile ? 50 : 96"
  >
    <v-container style="max-width: 1160px">
      <v-row :class="isMobile ? 'px-2' : ''">
        <v-col
          cols="12"
          md="12"
        >
          <base-section-heading
            :title="moduleBadge"
            :subtitle="moduleTitle"
            :is-uppercase="false"
            title-tag="h2"
            :space="6"
            align="left"
          />

          <base-body
            space="5"
            :html="moduleContent"
          />
        </v-col>
      </v-row>
      <v-row
        v-if="moduleImages && moduleImages.length"
        class="mt-2"
      >
        <v-col
          v-for="(imgUrl, idx) in moduleImages"
          :key="idx"
          cols="12"
          md="4"
        >
          <v-img
            :src="imgUrl"
            :alt="moduleTitle || moduleBadge || 'about us'"
            aspect-ratio="1.5"
            class="rounded"
            contain
          />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  import { mdiCloudOutline, mdiArrowRight } from '@mdi/js'
  export default {
    name: 'AboutUs',

    data: () => ({
      icon: {
        cloud: mdiCloudOutline,
        right: mdiArrowRight,
      },
      minHeight: 0,
      moduleBadge: '',
      moduleTitle: '',
      moduleContent: '',
      moduleImages: [],
    }),
    computed: {
      isMobile() {
        return this.$vuetify.breakpoint.width <= 768
      },
      hasRenderableContent() {
        return Boolean(
          String(this.moduleBadge || '').trim() ||
            String(this.moduleTitle || '').trim() ||
            String(this.moduleContent || '').trim() ||
            (this.moduleImages && this.moduleImages.some(url => !!url)),
        )
      },
    },
    watch: {
      '$i18n.locale'(newValue) {
        this.setMinHeight()
        this.loadModuleContent()
      },
    },
    mounted() {
      this.setMinHeight()
      this.loadModuleContent()
    },
    methods: {
      async loadModuleContent() {
        try {
          const modules = await this.$axios({
            method: 'get',
            url: '/public/modules/page/home',
            params: { lang: this.$i18n.locale },
          })
          const module = (modules || []).find(item => item?.moduleKey === 'about_us')
          if (!module) {
            this.moduleBadge = ''
            this.moduleTitle = ''
            this.moduleContent = ''
            this.moduleImages = []
            return
          }

          this.moduleBadge = module.title || ''
          this.moduleTitle = module.subtitle || ''
          this.moduleContent = module.content || ''
          this.moduleImages = []

          if (module.content) {
            try {
              const parsed = JSON.parse(module.content)
              if (parsed && typeof parsed === 'object') {
                this.moduleBadge = parsed.badge || this.moduleBadge
                this.moduleTitle = parsed.title || this.moduleTitle
                this.moduleContent = parsed.content || this.moduleContent
                if (Array.isArray(parsed.images)) {
                  this.moduleImages = parsed.images.filter(url => !!url)
                }
              }
            } catch {
            }
          }
        } catch (error) {
          this.moduleBadge = ''
          this.moduleTitle = ''
          this.moduleContent = ''
          this.moduleImages = []
        }
      },
      setMinHeight() {
        if (!this.isMobile) {
          this.minHeight = 0
          this.$nextTick(() => {
            if (this.$refs.content1 && this.$refs.content2) {
              const height1 = this.$refs.content1.$el.offsetHeight
              const height2 = this.$refs.content2.$el.offsetHeight
              this.minHeight = Math.max(height1, height2)
            }
          })
        }
      },
    },
  }
</script>

<style lang="sass" scoped>
.sub-title
  display: flex
  align-items: center
  justify-content: space-between
.ellipsis-text
  display: -webkit-box
  -webkit-line-clamp: 7
  -webkit-box-orient: vertical
  overflow: hidden
  text-overflow: ellipsis
</style>
